import { render } from "./Developer.vue?vue&type=template&id=371cd43d&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"

import "./Developer.vue?vue&type=style&index=0&id=371cd43d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371cd43d"]])

export default __exports__